import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import CallbackForm from "@/components/site/CallbackForm";
import { useSeo } from "@/lib/useSeo";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setA(false)); }, [slug]);
  useSeo(a ? (a.meta_title || a.title) : "Article", a ? (a.meta_description || a.excerpt) : "");

  if (a === false) return <div className="pt-40 pb-20 text-center text-ink/60">Article introuvable. <Link to="/conseils" className="text-primary">Retour</Link></div>;
  if (!a) return <div className="pt-40 pb-20 text-center text-ink/50">Chargement…</div>;

  return (
    <div>
      <section className="pt-32 pb-12 bg-ink">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/conseils" className="inline-flex items-center gap-2 text-white/70 hover:text-primary text-sm mb-4"><ArrowLeft size={16} /> Conseils</Link>
          <span className="overline text-primary">{a.type === "local" ? `${a.metier} · ${a.ville} (${a.code_postal})` : a.type === "faq" ? "FAQ" : "Conseil"}</span>
          <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-black text-white">{a.title}</h1>
        </div>
      </section>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {a.excerpt && <p className="text-xl text-ink/70 leading-relaxed mb-8 font-medium">{a.excerpt}</p>}
        <div className="article-body" dangerouslySetInnerHTML={{ __html: a.content }} />
        {a.keywords && <div className="mt-10 flex flex-wrap gap-2">{a.keywords.split(",").map((k) => <span key={k} className="text-xs bg-accent text-ink/60 px-3 py-1 rounded-full">{k.trim()}</span>)}</div>}
        <div className="mt-12 bg-secondary/40 rounded-2xl p-6 sm:p-8">
          <h3 className="font-heading text-xl font-black text-ink mb-4">Besoin d'un devis ?</h3>
          <CallbackForm source={`article:${slug}`} />
        </div>
      </article>
    </div>
  );
}
